import { render } from "./NewInfoCard.vue?vue&type=template&id=42284d3a&scoped=true"
import script from "./NewInfoCard.vue?vue&type=script&lang=js"
export * from "./NewInfoCard.vue?vue&type=script&lang=js"

import "./NewInfoCard.vue?vue&type=style&index=0&id=42284d3a&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42284d3a"]])

export default __exports__